<div class="bg-white rounded-lg shadow p-6">
  <div style="margin-top: -50px">
    <img
      class="w-14 m-auto"
      src="assets/logo-edvisor.svg"
      alt=""
    />
  </div>

  <div class="flex items-center justify-between mb-4">
    <h2 class="text-2xl font-medium">{{ 'commissionRequest:summary' | translate }}</h2>

    <span class="text-gray-500 text-sm">{{ commissionRequest?.id }}</span>
  </div>

  <div class="flex items-center justify-between border-t-2 border-t-neutral-400 pt-6">
    <span class="text-gray-500 text-sm">{{ 'commissions:columnStatus' | translate }}</span>
    <span class="badge badge-{{badgeStatusStyle}} text-sm">
      {{ badgeStatusLabel | translate }}
    </span>
  </div>

  <div class="pb-4">
    <div class="flex items-center justify-between pt-2">
      <span class="text-gray-500 text-sm">{{ 'commissionRequest:providerName' | translate }}</span>
      <span class="font-medium text-sm">{{ commissionRequest?.providerName }}</span>
    </div>

    <div
      *ngIf="hasPayment"
      class="flex items-center justify-between pt-2"
    >
      <span class="text-gray-500 text-sm">{{ 'commissionRequest:payingFrom' | translate }}</span>
      <div class="flex items-center font-medium text-sm">
        <img
          class="object-cover w-6 h-4 mr-2 border border-neutral-100"
          src="https://flagcdn.com/{{ countryPayFrom.toLowerCase() }}.svg"
          width="36"
          height="27"
          loading="lazy"
        />
        {{ 'country:' + countryPayFrom | translate }}
      </div>
    </div>

    <div
      *ngIf="hasPayment"
      class="flex items-center justify-between pt-2"
    >
      <span class="text-gray-500 text-sm">{{ 'commissionRequest:PaymentMethod' | translate }}</span>
      <span class="font-medium text-sm">{{ 'commissionRequest:bankTransfer' | translate }}</span>
    </div>

    <div *ngIf="!hasConvertedAmount">
      <div class="border-t-2 border-t-neutral-400 mt-4 pt-4">
        <div *ngIf="!loadingAmountToPay && !hasConvertedAmount">
          <span class="text-lg">
            {{ 'commissionRequest:pleaseSelectACountry' | translate }}
          </span>
        </div>

        <div *ngIf="loadingAmountToPay" class="pt-4">
          <mat-progress-spinner
            [diameter]="20"
            [mode]="'indeterminate'">
          </mat-progress-spinner>
        </div>
      </div>
    </div>

    <div *ngIf="hasConvertedAmount">
      <div class="border-t-2 border-t-neutral-400 mt-4 pt-4">
        <div class="flex flex-col gap-2">
          <span class="font-medium text-lg">{{
            'commissionRequest:' + (hasSuccessStatus ? 'weRequested' : 'weAreRequesting') | translate
          }}</span>
          <span class="text-3xl font-semibold text-blue-600">
            <ew-format-currency
              [amount]="paymentAmount!"
              [currency]="paymentCurrency!"
            ></ew-format-currency>
          </span>
        </div>
      </div>

      <div class="border-t-2 border-t-neutral-400 mt-4 pt-4">
        <div *ngIf="!loadingAmountToPay" class="flex flex-col gap-2">
          <span class="font-medium text-lg">{{
            'commissionRequest:' + (hasSuccessStatus ? 'youPaid' : 'youWillPay') | translate
          }}</span>
          <span class="text-3xl font-semibold text-green-600">
            <ew-format-currency
              [amount]="convertedAmount!"
              [currency]="convertedCurrency!"
            ></ew-format-currency>
          </span>
        </div>

        <div *ngIf="loadingAmountToPay" class="pt-4">
          <mat-progress-spinner
            [diameter]="20"
            [mode]="'indeterminate'">
          </mat-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
